<template>
  <el-dialog
    title="选择文章"
    :visible="value"
    center
    width="1300px"
    :before-close="beforeClose"
    :append-to-body="true"
  >
    <el-form
      :inline="true"
      :model="formData"
      class="demo-form-inline"
      size="medium"
    >
      <el-form-item label="文章编号">
        <el-input
          type="text"
          v-model="formData.articleIdList"
          placeholder="文章编号，请用英文逗号隔开"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="文章标题">
        <el-input
          type="text"
          v-model="formData.articleTitle"
          placeholder="文章标题"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="栏目">
        <el-select
          v-model="formData.columnIdList"
          multiple
          placeholder="请选择"
          collapse-tags
          clearable
          ><el-option
            v-for="item of columnData"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="formData.articleStatus"
          placeholder="请选择"
          clearable
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="显示" :value="1"></el-option>
          <el-option label="隐藏" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      row-key="articleId"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        fixed="left"
        type="selection"
        width="55"
        align="center"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column
        prop="articleId"
        label="文章编号"
        align="center"
      ></el-table-column>
      <el-table-column label="封面" align="center">
        <template slot-scope="scope">
          <img
            style="width: 40px;height: 40px;"
            :src="scope.row.coverImageUrl"
            alt=""
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="articleTitle"
        label="文章标题"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="columnName"
        label="栏目名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="viewCount"
        label="真实浏览量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="virtualViewCount"
        label="虚拟浏览量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="likeCount"
        label="真实点赞数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="virtualLikeCount"
        label="虚拟点赞数"
        align="center"
      ></el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.articleStatus === 1 ? "显示" : "隐藏" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateBy"
        label="修改人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
      ></el-table-column>
    </el-table>

    <div
      style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;"
    >
      <div class="text">已选中数量: {{ multipleSelection.length }}</div>
      <el-pagination
        background
        :current-page="page.pageIndex"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <div style="display: flex; align-items: center;justify-content: center;">
      <el-button size="small" @click="beforeClose">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="multipleSelection.length === 0"
        @click="confirm"
        >确认</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { getHealthArticleList } from "@/api/shop/article";
import { getHealthColumnList } from "@/api/shop/popcolumnManage";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    selectedList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    maxLength: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      multipleSelection: [],
      formData: {
        articleIdList: "",
        articleTitle: "",
        columnIdList: [],
        articleStatus: ""
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
        totalPage: ""
      },
      columnData: [],
      tableData: [],
      loading: false,
      temporarilySelectList: []
    };
  },
  created() {
    this.multipleSelection = this.selectedList;
  },
  mounted() {
    this.loadList();
    this.loadColumn();
  },
  methods: {
    handleSelect(selection, row) {
      return;
    },
    confirm() {
      if (this.multipleSelection.length > this.maxLength)
        return this.$message.error(`最多可选择${this.maxLength}个`);
      this.$emit("selected", this.multipleSelection);
    },
    beforeClose() {
      this.$emit("input", false);
    },
    reset() {
      this.formData = {
        articleIdList: "",
        articleTitle: "",
        columnIdList: [],
        articleStatus: ""
      };
      this.search();
    },
    search() {
      this.page.pageIndex = 1;
      this.tableData = [];
      this.loadList();
    },
    loadColumn() {
      //获取数据
      getHealthColumnList({
        pageIndex: 1,
        pageSize: 1000
      }).then(res => {
        const filtersArray = res.data.rows.filter(v => v.columnStatus == 1);
        this.columnData = filtersArray.map(item => {
          return {
            label: item.columnName,
            value: item.columnId
          };
        });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length > this.maxLength) {
        this.$message.closeAll()
        this.$message.warning(`最多可选择${this.maxLength}个`);
        const row = val[val.length - 1];
        this.$refs.multipleTable.toggleRowSelection(row, false);
      }
    },
    loadList() {
      const params = {
        ...this.formData,
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      params.articleIdList = params.articleIdList
        ? params.articleIdList.split(",")
        : [];
      this.loading = true;
      getHealthArticleList(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.data.rows;

          this.temporarilySelectList = this.multipleSelection;
          this.$refs.multipleTable.clearSelection();
          this.multipleSelection = this.temporarilySelectList;
          this.multipleSelection.forEach(item => {
            this.$refs.multipleTable.toggleRowSelection(item, true);
          });

          this.page.totalCount = res.data.count;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.page.pageIndex = val;
      this.loadList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.loadList();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/popularscienceManage/components/SelectArticle.vue